import React, { useState } from "react";
import classnames from "classnames";
import Chart from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import { chartOptions, parseOptions } from "variables/charts.js";
import DashboardModel from "./DashboardModel";
import { connect } from "react-redux";
import { getBranchMasterPage } from "Redux/Creators/BranchMasterCreators";
import { postDashboard } from "Redux/Creators/DDashboardCreators";
import moment from "moment";
import BranchDateFilter from "common/BranchDateFilter";

const Index = (props) => {
  const [branch, setBranch] = React.useState("all");
  const [from_date, setStartDate] = React.useState(
    moment().format("YYYY-MM-DD")
  );
  const [to_date, setEndDate] = React.useState(moment().format("YYYY-MM-DD"));
  const [activeNav, setActiveNav] = useState(1);
  const [day, setDay] = useState(0);
  // const [chartExample1Data, setChartExample1Data] = useState(props?.graph?.weeklyReport);

  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  const toggleNavs = (e, index) => {
    e.preventDefault();
    setActiveNav(index);
    // setChartExample1Data("data" + index);
  };

  React.useEffect(() => {
    fetchData();
    sendDefaultPayload();
  }, []);

  const fetchData = () => {
    const token = props.login?.login?.token;
    let data = {
      token: token,
    };
    props.getBranchMasterPage(data);
  };

  const sendDefaultPayload = () => {
    const token = props.login?.login?.token;
    props.postDashboard({
      token,
      body: { branch_id: branch, from_date, to_date },
    });
  };

  //These code is commented for static payload use
  // React.useEffect(() => {
  //   submitEmployeeAnalytics();
  // }, []);

  // const submitEmployeeAnalytics = async () => {
  //   const body = {
  //     from_date: "2023-01-01",
  //     to_date: "2025-09-01",
  //     company_branch_id: "all",
  //   };
  //   let data = {
  //     token: props.login?.login?.token,
  //     body: body,
  //   };
  //   props.postDashboard(data);
  // };
  console.log("dashboardState", props?.dashboardState?.dashboardState);

  // let lineData = {
  //   labels: Object.values(
  //     props?.dashboardState?.dashboardState?.data?.monthly_completed_cases
  //   ).map((el) => el.month),
  //   datasets: [
  //     {
  //       label: "Completed Cases",
  //       backgroundColor: "rgba(102, 200, 2, 0.5)", // Green for completed cases
  //       borderColor: "rgb(102, 200, 2)",
  //       borderWidth: 1,
  //       data: Object.values(
  //         props?.dashboardState?.dashboardState?.data?.monthly_completed_cases
  //       ).map((el) => el.completed_cases),
  //     },
  //     {
  //       label: "Ongoing Cases",
  //       backgroundColor: "rgba(238, 210, 2, 0.5)", // Yellow for ongoing cases
  //       borderColor: "rgb(238, 210, 2)",
  //       borderWidth: 1,
  //       data: Object.values(
  //         props?.dashboardState?.dashboardState?.data?.monthly_completed_cases
  //       ).map((el) => el.ongoing_cases),
  //     },
  //   ],
  // };
 const monthlyData = props?.dashboardState?.dashboardState?.data?.monthly_completed_cases || {};
 let lineData = monthlyData && Object.keys(monthlyData).length > 0
    ? {
        labels: Object.values(monthlyData).map((el) => el.month),
        datasets: [
          {
            label: "Completed Cases",
            backgroundColor: "rgba(102, 200, 2, 0.5)",
            borderColor: "rgb(102, 200, 2)",
            borderWidth: 1,
            data: Object.values(monthlyData).map((el) => el.completed_cases || 0),
          },
          {
            label: "Ongoing Cases",
            backgroundColor: "rgba(238, 210, 2, 0.5)",
            borderColor: "rgb(238, 210, 2)",
            borderWidth: 1,
            data: Object.values(monthlyData).map((el) => el.ongoing_cases || 0),
          },
        ],
      }
    : {
        labels: [],
        datasets: [
          { label: "Completed Cases", data: [], backgroundColor: "rgba(102, 200, 2, 0.5)" },
          { label: "Ongoing Cases", data: [], backgroundColor: "rgba(238, 210, 2, 0.5)" },
        ],
      };
  let lineData2 = {
    labels:
      props?.dashboardState?.dashboardState?.data?.pincode_initiation?.map(
        (el) => el.pincode
      ),
    datasets: [
      {
        label: "Cases",
        borderWidth: 1,
        backgroundColor: "rgba(238,210,2,.1)",
        borderColor: "rgb(238,210,2)",
        pointBorderColor: "rgb(238,210,2)",
        pointBackgroundColor: "rgb(238,210,2)",
        data: props?.dashboardState?.dashboardState?.data?.pincode_initiation?.map((o) => ({
          y: o.count,
          x: o.pincode,
        })),
        // data: [1, 2, 5, 7, 8, 10],
      },
    ],
  };
  let lineDataUsers = {
    labels: props?.graph?.dailyReportUserWise?.map((el) => el.pincode),
    datasets: [
      {
        label: "Users",
        borderWidth: 1,
        backgroundColor: "rgba(238,210,2,.1)",
        borderColor: "rgb(238,210,2)",
        pointBorderColor: "rgb(238,210,2)",
        pointBackgroundColor: "rgb(238,210,2)",
        data: props?.graph?.dailyReportUserWise?.map((o) => ({
          y: o.count,
          x: o.date,
        })),
        // data: [1, 2, 5, 7, 8, 10],
      },
    ],
  };
  const data6 = {
    labels:
      props?.dashboardState?.dashboardState?.data?.daily_company_branchwise_initiation?.map(
        (el) => el.company_branch_name
      ),
    datasets: [
      {
        label: "Cases",

        data: props?.dashboardState?.dashboardState?.data?.daily_company_branchwise_initiation?.map(
          (o) => ({
            y: o.count,
            x: o.company_branch_name,
          })
        ),
        backgroundColor: "rgba(205, 59, 252, 0.5)",
      },
    ],
  };
  const data = {
    labels: props?.dashboardState?.dashboardState?.data?.daily_release?.map(
      (el) => el.date
    ),
    datasets: [
      {
        label: "Cases",
        data: props?.dashboardState?.dashboardState?.data?.daily_release?.map(
          (o) => ({
            y: o.count,
            x: o.date,
          })
        ),
        backgroundColor: "rgba(102, 200, 2, 0.5)",
      },
    ],
  };
  const newData = {
    labels:
      props?.dashboardState?.dashboardState?.data?.daily_visits_initiated?.map(
        (el) => el.date
      ),
    datasets: [
      {
        label: "Cases",
        data: props?.dashboardState?.dashboardState?.data?.daily_visits_initiated?.map(
          (o) => ({
            y: o.count,
            x: o.date,
          })
        ),
        backgroundColor: "rgba(102, 200, 2, 0.5)",
      },
    ],
  };
  const dataUser = {
    labels:
      props?.dashboardState?.dashboardState?.data?.admin_productivity?.map(
        (el) => el.admin_name
      ),
    datasets: [
      {
        label: "Cases",
        data: props?.dashboardState?.dashboardState?.data?.admin_productivity?.map(
          (o) => ({
            y: o.cases_handled,
            x: o.admin_name,
          })
        ),
        backgroundColor: "rgba(102, 200, 2, 0.5)",
      },
    ],
  };
  const data8 = {
    labels:
      props?.dashboardState?.dashboardState?.data?.case_initiation_location_wise?.map(
        (el) => el.location
      ),
    datasets: [
      {
        label: "Cases",
        data: props?.dashboardState?.dashboardState?.data?.case_initiation_location_wise?.map(
          (o) => ({
            y: o.count,
            x: o.location,
          })
        ),
        backgroundColor: "rgba(102, 200, 2, 0.5)",
      },
    ],
  };

  const data4 = {
    labels: props?.graph?.dailyReportLocationWise?.map(
      // labels: props?.graph?.dailyReportReleaseInTat?.map(
      (el) => el.location
    ),
    datasets: [
      {
        label: "Report Release In Tat",
        data: props?.graph?.dailyReportLocationWise?.map((o) => ({
          // data: props?.graph?.dailyReportReleaseInTat?.map((o) => ({
          y: o.count,
          x: o.location,
        })),
        backgroundColor: "rgba(102, 200, 2, 0.5)",
      },
    ],
  };

  const rows =
    props.graph?.getBankStatsTableDashboard.length > 0
      ? props.graph?.getBankStatsTableDashboard?.initiated_case
      : [];

  // console.log("objectprops222111",props,props?.graph?.dailyReportDayWise,lineData)
  return (
    <>
      <header>
        <div className="header bg-gradient-info pb-8 pt-5 ">
          <Container fluid>
            <div className="header-body">
              <BranchDateFilter
                branchList={props.branchMaster?.branchMaster || []}
                branch={branch}
                from_date={from_date}
                to_date={to_date}
                setBranch={setBranch}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                onSubmit={(payload) => {
                  props.postDashboard({
                    ...payload,
                    token: props.login?.login?.token,
                  });
                }}
                pageName="Dashboard"
              />

              {/* Card stats */}
              <Row className="mt-2">
                <Col lg="6" xl="3" className="mt-2">
                  <Card className="card-stats h-100">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col>
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            OnGoing Cases
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {
                              props?.dashboardState?.dashboardState?.data
                                ?.counts?.ongoing_cases
                            }
                          </span>
                        </Col>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                            <i className="fas fa-chart-bar" />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="6" xl="3" className="mt-2">
                  <Card className="card-stats h-100">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col>
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Completed Cases
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {
                              props?.dashboardState?.dashboardState?.data
                                ?.counts?.completed_cases
                            }
                          </span>
                        </Col>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="fas fa-chart-pie" />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="6" xl="3" className="mt-2">
                  <Card className="card-stats h-100">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col>
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Total Cases
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {
                              props?.dashboardState?.dashboardState?.data
                                ?.counts?.total_cases
                            }
                          </span>
                        </Col>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                            <i className="fas fa-users" />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col lg="6" xl="3" className="mt-2">
                  <Card className="card-stats h-100">
                    <CardBody>
                      <Row className="align-items-center">
                        <Col>
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            Pending Allocations
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            {
                              props?.dashboardState?.dashboardState?.data
                                ?.counts?.pending_allocation_cases
                            }
                          </span>
                        </Col>
                        <Col className="col-auto">
                          <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                            <i className="fas fa-hourglass" />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </header>

      <Container className="mt--7" fluid>
        <Row>
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Cases
                    </h6>
                    <h2 className="text-white mb-0">{"Monthly Cases"}</h2>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  {/* <Line
                    data={chartExample1[chartExample1Data]}
                    options={chartExample1.options}
                    getDatasetAtEvent={(e) => console.log(e)}
                  /> */}
                  <Line
                    data={lineData}
                    options={{
                      tooltips: {
                        mode: "x-axis",
                      },
                      maintainAspectRatio: false,
                      legend: {
                        display: false,
                        labels: { fontFamily: "Nunito Sans" },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="6">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Visit Initiated
                    </h6>
                    {/* <h2 className="text-white mb-0">Monthly Cases</h2> */}
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      {/* <DashboardModelIndex name="dailyReportDayWise"/> */}
                    </Nav>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  <Bar
                    data={newData}
                    options={{
                      indexAxis: "Y",
                      responsive: true,
                      legend: {
                        display: true,
                        position: "top",

                        labels: {
                          boxHeight: 5,
                          boxWidth: 10,
                        },
                      },
                    }}
                  />
                </div>
                {/* horizontal bar graph */}
              </CardBody>
            </Card>
          </Col>

          <Col xl="6">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    {/* <h6 className="text-uppercase text-muted ls-1 mb-1">
                      Initiated Cases
                    </h6> */}
                    <h2 className="mb-0">Daily Report Release</h2>
                  </div>
                  {/* <DashboardModelIndex name="dailyReportRelease"/> */}
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  {/* <Bar
                    data={chartExample3.data}
                    options={chartExample3.options}
                  /> */}
                  <Bar
                    data={data}
                    options={{
                      responsive: true,

                      legend: {
                        display: true,
                        position: "top",

                        labels: {
                          boxHeight: 5,
                          boxWidth: 10,
                        },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-light ls-1 mb-1">
                      Admin Productivity
                    </h6>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  <Bar
                    data={dataUser}
                    options={{
                      responsive: true,

                      legend: {
                        display: true,
                        position: "top",

                        labels: {
                          boxHeight: 5,
                          boxWidth: 10,
                        },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    {/* <h6 className="text-uppercase text-light ls-1 mb-1">
                      Completed Cases
                    </h6> */}
                    <h2 className="text-white mb-0">
                      Daily Branchwise Intiation
                    </h2>
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      {/* <DashboardModelIndex name="dailyBankWiseReport"/> */}
                      {/* <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 1,
                          })}
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 1)}
                        >
                          <span className="d-none d-md-block">Month</span>
                          <span className="d-md-none">M</span>
                          </NavLink>
                        </NavItem> */}
                      {/* <NavItem>
                        <NavLink
                          className={classnames("py-2 px-3", {
                            active: activeNav === 2,
                          })}
                          data-toggle="tab"
                          href="#pablo"
                          onClick={(e) => toggleNavs(e, 2)}
                        >
                        <span className="d-none d-md-block">Week</span>
                          <span className="d-md-none">W</span>
                        </NavLink>
                      </NavItem> */}
                    </Nav>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  <Bar
                    data={data6}
                    options={{
                      responsive: true,
                      title: {
                        text: "Daily Branchwise Intiation",
                        display: true,
                      },

                      legend: {
                        display: true,
                        position: "top",

                        labels: {
                          boxHeight: 5,
                          boxWidth: 10,
                        },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="7">
            <Card className="bg-gradient-default shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    {/* <h6 className="text-uppercase text-light ls-1 mb-1">
                      Completed Cases
                    </h6> */}
                    <h2 className="text-white mb-0">
                      Case Initiation Location Wise
                    </h2>
                  </div>
                  <div className="col">
                    <Nav className="justify-content-end" pills>
                      {/* <DashboardModelIndex name="dailyReportLocationWise"/> */}
                    </Nav>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  <Bar
                    data={data8}
                    options={{
                      responsive: true,

                      legend: {
                        display: true,
                        position: "top",

                        labels: {
                          boxHeight: 5,
                          boxWidth: 10,
                        },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="5">
            <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h2 className="mb-0">Pincode Initiation</h2>
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
                {/* Chart */}
                <div className="chart">
                  <Bar
                    data={lineData2}
                    options={{
                      tooltips: {
                        mode: "x-axis",
                      },
                      maintainAspectRatio: false,
                      legend: {
                        display: false,
                        labels: { fontFamily: "Nunito Sans" },
                      },
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row></Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    login: state.login,
    graph: state.graph,
    branchMaster: state.branchMaster,
    dashboardState: state.dashboard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBranchMasterPage: (data) => dispatch(getBranchMasterPage(data)),
    postDashboard: (data) => dispatch(postDashboard(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
